import { Injectable } from '@angular/core';
import { setActiveDashboardShareLinkGuid } from './dashboard-share-link-api';

/**
 * Optional context for loading dashboard config and widget data via a public share link.
 */
@Injectable({ providedIn: 'root' })
export class DashboardShareLinkContext {
  private _guid: string | null = null;
  private _active = false;

  setShareLink(guid: string | null): void {
    this._guid = guid;
    this._active = !!guid;
    setActiveDashboardShareLinkGuid(guid);
  }

  get isActive(): boolean {
    return this._active && !!this._guid;
  }

  get guid(): string | null {
    return this._guid;
  }

  clear(): void {
    this._guid = null;
    this._active = false;
    setActiveDashboardShareLinkGuid(null);
  }

  /** Widget data POST path segment (replaces /dashboard/data/:type). */
  dataUrlForType(type: string): string | null {
    if (!this.isActive || !this._guid) {
      return null;
    }
    return `/dashboard/share-links/${encodeURIComponent(this._guid)}/data/${encodeURIComponent(type)}`;
  }

  educationalPathsUrl(): string | null {
    if (!this.isActive || !this._guid) {
      return null;
    }
    return `/dashboard/share-links/${encodeURIComponent(this._guid)}/educational-paths`;
  }
}
